import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

import ResourceThumb from '../../components/ResourceThumb.jsx';

/**
 * Fila compacta de un recurso ya seleccionado, dentro de la tarjeta de su unidad.
 *
 * Es el único lugar desde donde se quita un recurso: sin esto habría que volver
 * a navegar el catálogo hasta la carpeta donde está para poder deseleccionarlo.
 *
 * Props:
 * - type: entrada de RESOURCE_TYPES (aporta el ícono y los estilos del tipo).
 * - entry: { key, path, name, thumbnail } tal como se guarda en `selections`.
 * - onRemove(): quita este recurso de la unidad.
 */
const SelectedResourceRow = ({ type, entry, onRemove }) => (
  <div className={`flex items-center gap-3 rounded-lg border px-3 py-2 ${type.card}`}>
    <ResourceThumb thumbnail={entry.thumbnail} Icon={type.Icon} tile={type.tile} />
    <span className='min-w-0 flex-1 truncate text-left text-sm font-medium text-primary'>
      {entry.name}
    </span>
    <button
      type='button'
      onClick={onRemove}
      title='Quitar recurso'
      aria-label={`Quitar ${entry.name}`}
      className='flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-muted-foreground transition duration-150 hover:bg-white hover:text-primary'>
      <CloseIcon fontSize='small' />
    </button>
  </div>
);

export default SelectedResourceRow;
